// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__21Hyc","addWidgetButton":"Header_addWidgetButton__1MZCS","dashboardTabs":"Header_dashboardTabs__1empc","active":"Header_active__2-nir"};